module.exports = __webpack_public_path__ + "src/assets/img/5.49a6cdfc.jpg";